import entry from '#shared/util/entry.js';
import createTheme from '#shared/util/createTheme.js';
import store from '#shared/store/store.js';

import parentComponent from './components/global/global.js';
import errorComponent from './components/error/error.js';
import routes from './routes.js';
import config from './config.js';

const app = () => createTheme(Object.assign({}, {
	theme: 'web',
	routes,
	store: store(),
	parentComponent,
	errorComponent
}, config));

export default IS_SERVER ? () => entry(app()) : entry(app());
